import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { Stack } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import ClockingsToolbar from './clockings/ClockingsToolbar';
import NavBar from './cometeLink/Navbar';
import { BottomNavigationBar, Sidebar } from './nav';
import Breadcrumbs from './nav/Breadcrumbs';
import { HamburgerMenu } from './clockings';
import { MHidden } from '../@material-extend';

import useAuth from '../../hooks/useAuth';
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
import useLayout from '../../hooks/useLayout';
import { isOnTimeUserLogin } from '../../utils/sessionFlags';

const PADDING_TOP = 72;

const MainStyleResource = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: PADDING_TOP,
  [theme.breakpoints.up('sm')]: {
    paddingTop: PADDING_TOP + 24,
    paddingBottom: theme.spacing(1)
  },
  [theme.breakpoints.up('md')]: {
    paddingTop: PADDING_TOP + 24,
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5)
  },
  [theme.breakpoints.up('lg')]: {
    paddingTop: PADDING_TOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  }
}));

const LayoutClockings = () => {
  const styleMain = useLayout();
  const location = useLocation();
  const theme = useTheme();
  const { user } = useAuth();
  const { collapseClick } = useCollapseDrawer();
  // Layout link uniquement après connexion OnTime (email ou code agent MCE).
  // Sans ce flag, l'agent/client est sur la page de pointage générique : layout minimaliste comme le manager.
  const isEmailLogin = isOnTimeUserLogin();
  const isResource = user?.role === 'resource' && isEmailLogin;
  const isClient = user?.role === 'client' && isEmailLogin;
  const isManagerEmailLogin = user?.role === 'manager' && isEmailLogin;
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const showHamburgerMenu =
    location.pathname === '/pointages/' ||
    location.pathname === '/pointages' ||
    location.pathname === '/pointages/pairing' ||
    location.pathname === '/pointages/settings' ||
    location.pathname === '/pointages/home' ||
    location.pathname === '/pointages/client-home' ||
    location.pathname === '/pointages/manager-home';

  // Agent / Client / Manager (email login) : layout Comète Link (NavBar + Sidebar + BottomNav)
  if (isResource || isClient || isManagerEmailLogin) {
    return (
      <div className="clockings-root" style={{ display: 'flex', minHeight: '100%', overflow: 'hidden' }}>
        <NavBar onOpenSidebar={() => setSidebarOpen(true)} />

        <MHidden width="smDown">
          <Sidebar isOpenSidebar={sidebarOpen} onCloseSidebar={() => setSidebarOpen(false)} />
        </MHidden>

        <MHidden width="smUp">
          <BottomNavigationBar />
        </MHidden>

        <MainStyleResource
          className="clockings-main"
          sx={{
            marginTop: 'env(safe-area-inset-top) !important',
            marginBottom: window.env.isIos ? 0 : 'env(safe-area-inset-bottom) !important',
            overflow: 'auto',
            transition: theme.transitions.create('margin', {
              duration: theme.transitions.duration.complex
            }),
            ...(collapseClick && { ml: '102px' })
          }}
        >
          <Outlet />
        </MainStyleResource>
      </div>
    );
  }

  // Manager / Clocking device : layout On Time classique
  return (
    <Stack className="clockings-root" sx={styleRoot}>
      <ClockingsToolbar>
        <Breadcrumbs themed />
        {showHamburgerMenu && <HamburgerMenu />}
      </ClockingsToolbar>

      <Stack className="clockings-main" sx={styleMain}>
        <Outlet />
      </Stack>
    </Stack>
  );
};

const styleRoot = {
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
};

export default LayoutClockings;
